import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'estado-tarea',
  templateUrl: './estado-tarea.component.html',
})
export class EstadoTareaComponent {

  @Input() value: string;
  @Input() rowData: any;

  @Output() asignar = new EventEmitter<any>();

  asignarTarea() {
    this.asignar.emit(this.rowData);
  }

}